<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar />
      </flex-col>
      <flex-col :span="24">
        <card>
          <card-text :class="['p-4']">
            <divider />
          </card-text>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
export default {
  name: 'PageDivider'
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/divider.vue